<template>
  <div ref="chartContainer" style="width: 100%; height: 100%">
    <div v-if="renderGraph" style="width: 100%; height: 100%">
      <apexchart
        :height="height"
        :width="`${chartWidth}px`"
        :options="options"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["height", "options", "series"],
    data: () => ({
      chartWidthDebounce: null,
      chartWidth: 300,
      renderGraph: false,
      checkRender: null,
    }),
    methods: {
      handleResize() {
        this.renderGraph = false;
        clearTimeout(this.chartWidthDebounce);

        this.chartWidthDebounce = setTimeout(() => {
          this.chartWidth = this.$refs.chartContainer.clientWidth;
          this.renderGraph = true;
        }, 100);
      },
    },
    beforeDestroy: function () {
      window.removeEventListener("resize", this.handleResize);
      clearInterval(this.checkRender);
    },
    mounted() {
      setTimeout(() => {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.checkRender = setInterval(() => {
          if (this.chartWidth != this.$refs.chartContainer.clientWidth) {
            this.handleResize();
          }
        }, 500);
      }, 100);
    },
  };
</script>